// Local
import { WindowRef } from '@core/native-window.util';

export class BrowserWindowRef extends WindowRef {
  public override get nativeWindow(): Window {
    return window;
  }
}
